import { navigate } from "gatsby";
import React, { ReactNode } from "react";
import ActionButton from "./ActionButton";

  
export default ({ children }: { children: ReactNode }): JSX.Element => (
  <ActionButton isValid={true} type='button' onClick={() => navigate('/owned-events')}>
    {children}
  </ActionButton>
)